export default __webpack_public_path__ + "static/media/javascript-plain.bacc3387.svg";